import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-kebab-menu',
    templateUrl: './kebab-menu.component.svg',
    styleUrls: ['./kebab-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KebabMenuComponent {}
